import React, { Component } from 'react';
import Loader from "../../../../Common/Component/Loader";
import {isEmpty} from "lodash";
import moment from "moment-timezone";
import {CameraOutlined} from '@ant-design/icons';
import PreviewModal from "../Common/PreviewModal";
import {convertFirstCharToUppercase} from "../../../../../Tools/convertFirstLetterToUppercase";
import { aboutUsData } from "../../../../../Assets/data/aboutUsList";

const communityRoleData = {board_member: 'Board Member', community_manager: 'Community Manager', concerned_resident: 'Concerned Resident'}
const communityTypeData = {townhomes: 'Townhomes', detached: 'Detached Homes', condo: 'Condominium', apartment: 'Apartment'}
const serviceData = {pet_waste_station_service: 'Pet Waste Station Service', common_area_cleaning: 'Common Area Cleaning', trash_can_service: 'Trash Can Service'}
const productData = {pet_waste_stations: 'Pet Waste Stations', pet_waste_station_bags: 'Pet Waste Station Bag'}
const bagsData = {header_bags: 'Header Bags', roll_bags: 'Roll Bags', dont_know: 'I Don’t Know'}
const stationInstallingData = {'1-5': '1-5', '6-10': '6-10', '11-20+': '11-20+', 'dont_know': 'I Don’t Know'}
const serviceFrequencyData = {'twice weekly': 'Twice Weekly', 'weekly': 'Weekly', 'every other week': 'Every Other Week', 'other': 'Other'}
const cleaningAreasData = {all_common_areas: 'All Common Areas', specific_locations: 'Specific Locations'}

class AccountDetails extends Component {
  state = {
    loader: false,
    showPreview: false,
    selectedImage: '',
    title: '',
    quoteDetail: {}
  }

  componentDidMount = () => {
    const {quoteId, getQuoteById} = this.props;
    getQuoteById && getQuoteById(quoteId)
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // get quote detail
    if (Object.keys(nextProps?.CommercialProposal?.getQuoteDetail).length > 0
      && JSON.stringify(nextProps?.CommercialProposal?.getQuoteDetail) !== JSON.stringify(this.state.getQuoteDetail)) {
      this.setState({quoteDetail: nextProps?.CommercialProposal?.getQuoteDetail})
    }
  }

  // toggle preview
  togglePreview = () => {
    this.setState((prevState) => ({showPreview: !prevState.showPreview}))
  }

  // format phone number
  formatPhoneNumber = (phone) => {
    phone = phone?.replace(/\D/g, '');
    return phone?.substr(0, 3) + ' ' + phone?.substr(3, 3) + ' ' + phone?.substr(6);
  }

  // convert date time from utc to local time
  UTCToLocal = (date) => {
    let stillUtc = moment.utc(date).toDate();
    return moment(stillUtc).local();
  }

  // convert date time from local to utc
  localToUTC = (date) => {
    return moment.utc(date)
  }

  // render primary info
  renderPrimaryInfo = () => {
    const {quoteDetail} = this.state;
    const phone_number = quoteDetail?.phone_numbers?.find((obj) => obj.primary === true)
    const account_holder = {user_name: quoteDetail?.community_name, phone_number: phone_number?.phone, email: quoteDetail?.email_address};

    return (
      <div className="card">
        <div className="card-title">
          <h5>Primary Information</h5>
        </div>
        <div className="card-body">
          {!isEmpty(account_holder) ?
            <div>
              <div className="flex flex-start mb-10">
                <div className="label">
                  <b>Account Holder:</b>
                </div>
                <div className="value">
                  <b>{account_holder?.user_name}</b>
                </div>
              </div>
              <div className="mb-10">{account_holder?.phone_number ? `+1 ${this.formatPhoneNumber(account_holder?.phone_number)} (Primary)` : ''}</div>
              <div>{`${account_holder?.email} (Primary)`}</div>
            </div> : ''
          }
        </div>
      </div>
    )
  };

  // render pet waste details
  renderPetWaste = () => {
    const {quoteDetail} = this.state;
    const bagData = quoteDetail?.bag_type?.map(x => bagsData[x])
    return (
      <div>
        <div  className='mb-10'>
          <b>{'Pet Waste Stations'}</b>
        </div>
        <div className='mb-10'>
          <b>Does the community have pet waste stations installed?</b>
          <div className='mt-10'>{quoteDetail?.is_pet_waste_stations_installed ? 'Yes' : 'No'}</div>
        </div>
        {
          quoteDetail?.is_pet_waste_stations_installed ?
            <div>
              <div className='mb-10'>
                <b>How many pet waste station do you have?</b>
                <div className='mt-10'>{quoteDetail?.existing_pet_waste_stations_count}&nbsp;
                  {quoteDetail?.pet_waste_station_map ? <a href='/#'
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({selectedImage: quoteDetail?.pet_waste_station_map, title: 'PWS Station Map'}, () => this.togglePreview())}
                    }>
                    <CameraOutlined /> Image attached</a> : ''}</div>
              </div>
              <div className='mb-10'>
                <b>What type of bag do you used?</b>
                <div className='mt-10'>{bagData?.join(', ')}</div>
              </div>
              <div className='mb-10'>
                <b>What is current frequency of service?</b>
                <div className='mt-10'>{serviceFrequencyData[quoteDetail?.current_frequency]}</div>
              </div>
            </div> :
            <div className='mb-10'>
              <b>How many pet waste station are you interested?</b>
              <div className='mt-10'>{stationInstallingData[quoteDetail?.new_pet_waste_stations_interested]}</div>
            </div>
        }
        <hr/>
      </div>
    )
  }

  // render common area cleaning
  renderCommonAreaCleaning = () => {
    const {quoteDetail} = this.state;
    const areaToClean = quoteDetail?.areas_to_clean?.map(x => cleaningAreasData[x])

    return (
      <div>
        <div className='mb-10'>
          <b>{'Common Area Cleaning'}</b>
        </div>
        <div className="mb-10">
          <b>Areas to clean</b>
          <div className='mt-10'>{areaToClean?.join(', ')}&nbsp;
            {quoteDetail?.common_area_cleaning_map ?
              <a href='/#'
                onClick={(e) => {
                  e.preventDefault();
                  this.setState({selectedImage: quoteDetail?.common_area_cleaning_map, title: 'Common Area Cleaning Map'}, () => this.togglePreview())}}>
                <CameraOutlined /> Image attached</a> : ''}
          </div>
        </div>
        <hr/>
      </div>
    )
  }

  //render trash can
  renderTrashCan = () => {
    const {quoteDetail} = this.state;
    return (
      <div>
        <div className='mb-10'>
          <b>{'Trash Can'}</b>
        </div>
        <div className='mb-10'>
          <b>Does the community have pet waste stations installed?</b>
          <div className='mt-10'>{quoteDetail?.is_trash_cans_installed ? 'Yes' : 'No'}</div>
        </div>
        {
          quoteDetail?.is_trash_cans_installed ?
            <div>
              <div className='mb-10'>
                <b>How many pet waste station do you have?</b>
                <div className='mt-10'>{quoteDetail?.trash_cans_count}&nbsp;
                  {quoteDetail?.trash_can_location_map ?
                    <a href='/#'
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({selectedImage: quoteDetail?.trash_can_location_map, title: 'Trash Can Location Map'}, () => this.togglePreview())
                      }}><CameraOutlined /> Image attached</a> : ''}
                </div>
              </div>
              <div className='mb-10'>
                <b>What is current frequency of service?</b>
                <div className='mt-10'>{serviceFrequencyData[quoteDetail?.current_frequency]}</div>
              </div>
            </div> :
            <div className='mb-10'>
              <b>How many pet waste station are you interested?</b>
              <div className='mt-10'>{stationInstallingData[quoteDetail?.new_trash_cans_interested]}</div>
            </div>
        }
        <hr/>
      </div>
    )
  }

  // Render Source & Attribution
  renderSourceAndAttribution = () => {
    const {quoteDetail} = this.state;
    const temp = aboutUsData.filter(item => quoteDetail?.hear_about_us?.includes(item.value)).map(item2 => {return item2.name}).join(', ');
    const formatted_attribution = quoteDetail?.channel_attribution && quoteDetail?.channel_attribution.name !== 'Unknown' ? convertFirstCharToUppercase(quoteDetail?.channel_attribution.name) : '-';
    const formatted_outreach = quoteDetail?.outreach ? convertFirstCharToUppercase(quoteDetail?.outreach.replace("_", " ")) : '-';

    return (
      <div className="card">
        <div className="card-title">
          <h5>Source & Attribution</h5>
        </div>
        <div className="card-body">
          <span>
            Outreach: <b style={{marginLeft: "5px", padding: "0"}}>{formatted_outreach}</b>
          </span><br/>
          <span>How do you hear about us:
            {
              quoteDetail?.hear_about_us?.length > 0 ?
                <b style={{marginLeft: "5px"}}>{temp}</b>
                : null
            }
          </span><br/>
          <span>
            Attribution:
            <b style={{marginLeft: "5px", maxWidth: "none"}}>{formatted_attribution}</b>
          </span><br/>
        </div>
      </div>
    );
  };

  // render proposal detail
  renderProposalDetail = () => {
    const {quoteDetail} = this.state;
    const isPetWasteStation = quoteDetail?.interested_services?.includes("pet_waste_station_service");
    const isCommonCleaningArea = quoteDetail?.interested_services?.includes("common_area_cleaning");
    const isTrashCan = quoteDetail?.interested_services?.includes("trash_can_service");
    const properties = quoteDetail?.properties_in_community?.map(x => communityTypeData[x])
    const services = quoteDetail?.interested_services?.map(x => serviceData[x])
    const products = quoteDetail?.interested_products?.map(x => productData[x])

    return (
      <div className="card">
        <div className="card-title flex">
          <h5>Proposal Information</h5>
          <button className="btn btn-warning"
            onClick={(e) => {
              e.preventDefault();
              this.props.history.push('/commercial/new-proposal', { query: { 'quoteDetail': quoteDetail } })
            }}>Update</button>
        </div>
        <div className="card-body">
          <div className='mb-10'>
            <b>Community Information</b>
          </div>
          <div className='mb-10'>
            <b>What is your role in community?</b>
            <div className='mt-10'>{communityRoleData[quoteDetail?.role]}</div>
          </div>
          <div className='mb-10'>
            <b>{`What's in your community?`}</b>
            <div className='mt-10'>{quoteDetail?.properties_in_community?.length > 0 ? properties?.join(', ') : ''}</div>
          </div>
          <div className='mb-10'>
            <b>{`Looking for`}</b>
            <div className='mt-10'>{quoteDetail?.is_looking_for_proposal ? 'Proposal' : quoteDetail?.would_like_more_info ? 'More Info' : ''}</div>
          </div>
          <div className='mb-10'>
            <b>{`What date is your proposal due?`}</b>
            <div className='mt-10'>{quoteDetail?.proposal_due ? moment(quoteDetail?.proposal_due).format('ddd, MMM DD YYYY') : ''}</div>
          </div>
          <div className='mb-10'>
            <b>What are you looking for?</b>
            <div className='mt-10'>{quoteDetail?.is_looking_for_proposal ? 'Proposal' : quoteDetail?.would_like_more_info ? 'More Info' : ''}</div>
          </div>
          <div className="mb-10">
            <b>{`Sample address in community`}</b>
            {
              !isEmpty(quoteDetail?.address) ?
                <div className='mt-10'>
                  <div>{quoteDetail?.address?.address},</div>
                  <div>{`${quoteDetail?.address?.city}, ${quoteDetail?.address?.state}, ${quoteDetail?.address?.zip_code}`}</div>
                </div> : ''
            }
          </div>
          <hr/>
          <div className='mb-10'>
            <b>Service Information</b>
          </div>
          <div className='mb-10'>
            <b>What services are you interested in?</b>
            <div className='mt-10'>{services?.join(', ')}</div>
          </div>
          <div className='mb-10'>
            <b>What products are you interested in?</b>
            <div className='mt-10'>{products?.join(', ')}</div>
          </div>
          <hr/>
          {isPetWasteStation && this.renderPetWaste()}
          {isCommonCleaningArea && this.renderCommonAreaCleaning()}
          {isTrashCan && this.renderTrashCan()}
          <div className='mb-10'>
            <b>Additional comments</b>
            <div className='mt-10'>{quoteDetail?.additional_comments}</div>
          </div>
        </div>
      </div>
    )
  }

  // Render Source and attribution
  renderSourceAttribution = () => {
    const { customer } = this.state;
    const { hearAboutUs } = this.props;

    return (
      <div className="card">
        <div className="card-title">
          <h5>Source &amp; Attribution</h5>
        </div>
        <div className="card-body">
          {/* <span>{`Outreach: ${customer?.outreach ? outreach[customer?.outreach] : ''}`}</span><br/> */}
          <span>{`How did you hear about us: `} <b>{!isEmpty(hearAboutUs) ? `${aboutUsData.filter(item => hearAboutUs?.includes(item.value)).map(item2 => {return item2.name}).join(', ')}` : '-'}</b></span>
        </div>
      </div>
    )
  };

  render() {
    const {loader, selectedImage, showPreview, title} = this.state;

    return (
      <div className="block-row">
        <div className="card-row hide-lg">
          {loader && <Loader />}
          <div className="card-col">
            {this.renderPrimaryInfo()}
          </div>
          <div className="card-col">
            {this.renderProposalDetail()}
            {this.renderSourceAndAttribution()}
          </div>
          <div className="card-col"/>
        </div>
        <div className="card-row show-lg">
          {loader && <Loader />}
          <div className="card-col">
            {this.renderPrimaryInfo()}
          </div>
          <div className="card-col">
            {this.renderProposalDetail()}
          </div>
          <div className="card-col"/>
        </div>
        <PreviewModal
          visible={showPreview}
          title={title}
          imageUrl={selectedImage}
          handleCancel={() => this.togglePreview()}
        />
      </div>
    );
  }
}

export default AccountDetails;
